import { JobChangeIntervalUnit } from "@/enum/list.enum";

// Default job-change tracking intervals applied to new lists in the settings form.
export const DEFAULT_JOB_CHANGE_INTERVALS = {
	prio1: 3,
	prio1Unit: JobChangeIntervalUnit.MONTHS,
	prio2: 3,
	prio2Unit: JobChangeIntervalUnit.MONTHS,
	prio3: 3,
	prio3Unit: JobChangeIntervalUnit.MONTHS,
} as const;

// Default signal-scoring intervals applied to TRACKER lists in the settings form.
export const DEFAULT_SIGNAL_INTERVALS = {
	prio1: 2,
	prio1Unit: JobChangeIntervalUnit.WEEKS,
	prio2: 1,
	prio2Unit: JobChangeIntervalUnit.MONTHS,
	prio3: 2,
	prio3Unit: JobChangeIntervalUnit.MONTHS,
} as const;
